import React from 'react';
import styled from 'styled-components';

import { Field, Form } from 'react-final-form'
import { Loading, Button, PlaceholderInput } from '../common';
import { useHistory } from 'react-router-dom';

const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
`

const FieldWrapper = styled.div`
    width: 100%;
    margin: 10px 0 20px 0;
    display: flex;
    flex-direction: column;
    align-items: center;
`

const ForgetPasswordLink = styled.button`
    background: none;
    border: none;
    font-size: 11px;
    color: ${props => props.theme.colors.textPrimary};
    margin: 10px 0;
`

const FormContent = styled.div`
    width: 80%;
    display: flex;
    flex-direction: column;
`

export const LoginForm = ({ handleLogin, loading, multistore }) => {

    const required = (value) => value ? undefined : 'Obrigatório';
    const history = useHistory();

    return (
        <Form
            onSubmit={handleLogin}
            subscription={{ submitting: true }}
            render={({ handleSubmit }) => (
                <form onSubmit={handleSubmit}>
                    <Wrapper>
                        <FormContent>
                            {!multistore && (
                                <FieldWrapper>
                                    <Field name="storeId" validate={required}>
                                        {({ input, meta }) => {
                                            const error = meta.touched && meta.error
                                            return (
                                                <PlaceholderInput {...input} name="storeId" error={error} width={"100%"} placeholder="Código da loja *" keepPlaceholderAbove />
                                            )
                                        }}
                                    </Field>
                                </FieldWrapper>
                            )}
                            <FieldWrapper>
                                <Field name="user" validate={required}>
                                    {({ input, meta }) => {
                                        const error = meta.touched && meta.error
                                        return (
                                            <PlaceholderInput {...input} name="user" error={error} width={"100%"} placeholder="Usuário *" keepPlaceholderAbove />
                                        )
                                    }}
                                </Field>
                            </FieldWrapper>
                            <FieldWrapper>
                                <Field name="pass" validate={required}>
                                    {({ input, meta }) => {
                                        const error = meta.touched && meta.error
                                        return (
                                            <PlaceholderInput {...input} name="pass" error={error} type="password" width={"100%"} placeholder="Senha *" keepPlaceholderAbove />
                                        )
                                    }}
                                </Field>
                            </FieldWrapper>
                            {loading
                                ? (
                                    <FieldWrapper>
                                        <Loading />
                                    </FieldWrapper>
                                )
                                : (
                                    <FieldWrapper>
                                        <Button type="submit" className="success">
                                            ENTRAR
                                        </Button>
                                        <ForgetPasswordLink>
                                            ESQUECI MINHA SENHA
                                        </ForgetPasswordLink>
                                        <Button
                                            style={{ marginTop: '8px' }}
                                            onClick={() => history.push({ pathname: multistore ? '/' : '/multilojas' })}
                                        >
                                            {multistore ? 'Login loja' : 'Login multilojas'}
                                        </Button>
                                    </FieldWrapper>
                                )
                            }

                        </FormContent>
                    </Wrapper>
                </form>
            )}
        />
    )
}